import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  EditSubdomain,
  Testimonials,
  Gallery,
  CoverSection,
  AboutYou,
  SocialLinks,
  ContactInfo,
  UploadLogo,
  DefaultSection,
  Features,
  Statistics,
  OfferingsSection,
  IntroVideo,
  AdditionalPointers,
  Blogs,
  Teams,
  AboutSection,
} from "./components";

import { SIDEBAR_KEYS } from "../../constants";
import Awards from "./components/CreatorMiscellaneousData/Awards";
import BrandCollaborations from "./components/CreatorMiscellaneousData/BrandCollaborations";
import MediaMentions from "./components/CreatorMiscellaneousData/MediaMentions";
import { ThemeColors } from "./components/ThemeColors";
import { CustomFooter } from "./components/CreatorMiscellaneousData/CustomFooter";

const SIDEBAR_ENUM = {
  [SIDEBAR_KEYS.SUBDOMAIN]: EditSubdomain,
  [SIDEBAR_KEYS.COVER]: CoverSection,
  [SIDEBAR_KEYS.ABOUT_YOU]: AboutYou,
  [SIDEBAR_KEYS.SOCIAL]: SocialLinks,
  [SIDEBAR_KEYS.AWARDS]: Awards,
  [SIDEBAR_KEYS.BRAND_COLLABORATIONS]: BrandCollaborations,
  [SIDEBAR_KEYS.MEDIA_MENTIONS]: MediaMentions,
  [SIDEBAR_KEYS.CONTACT_DETAILS]: ContactInfo,
  [SIDEBAR_KEYS.TESTIMONIALS]: Testimonials,
  [SIDEBAR_KEYS.GALLERY]: Gallery,
  [SIDEBAR_KEYS.LOGO]: UploadLogo,
  [SIDEBAR_KEYS.COLORS]: ThemeColors,
  [SIDEBAR_KEYS.FEATURES]: Features,
  [SIDEBAR_KEYS.STATISTICS]: Statistics,
  [SIDEBAR_KEYS.OFFERINGS_SECTION]: OfferingsSection,
  [SIDEBAR_KEYS.INTRO_VIDEO]: IntroVideo,
  [SIDEBAR_KEYS.ADDITIONAL_POINTERS]: AdditionalPointers,
  [SIDEBAR_KEYS.BLOGS]: Blogs,
  [SIDEBAR_KEYS.TEAMS]: Teams,
  [SIDEBAR_KEYS.ABOUT_SECTION]: AboutSection,
  [SIDEBAR_KEYS.CUSTOM_FOOTER]: CustomFooter,
};

const Section = (props) => {
  const {
    sectionKey,
    state,
    initialState,
    setState,
    setField,
    templateData,
    errorState,
    setErrorMessage,
    enableError,
    disableAllEdits,
    hiddenFields,
    other: {
      fontList,
      fontListMeta,
      loadMoreFonts,
      isFontListLoading,
      fontSearch,
      handleFontSearchChange,
      totalFonts,
      checkSubdomainValid,
    },
  } = props;

  const errorHandlerToggle = (
    fieldKey,
    { noFocus = false, noBlur = false } = { noFocus: false, noBlur: false }
  ) => ({
    ...(!noBlur && {
      onBlur: () => {
        enableError(fieldKey);
      },
    }),
    ...(!noFocus && {
      onFocus: () => {
        enableError(fieldKey, false);
      },
    }),
  });

  const [timer, setTimer] = useState(null);

  const debounce = (updateFunc, timerVal = 250) => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(setTimeout(updateFunc, timerVal));
  };

  const sectionProps = {
    state,
    setState,
    initialState,
    setField,
    errorState,
    setErrorMessage,
    debounce,
    checkSubdomainValid,
    errorHandlerToggle,
    disableAllEdits,
    hiddenFields,
    fontList,
    fontListMeta,
    loadMoreFonts,
    isFontListLoading,
    fontSearch,
    handleFontSearchChange,
    totalFonts,
    templateData,
    enableError,
  };

  const SectionComponent =
    sectionKey in SIDEBAR_ENUM ? SIDEBAR_ENUM[sectionKey] : DefaultSection;

  return <SectionComponent {...sectionProps} />;
};

Section.propTypes = {
  sectionKey: PropTypes.string,
  initialState: PropTypes.object,
  state: PropTypes.object,
  setState: PropTypes.func,
  setField: PropTypes.func,
  errorState: PropTypes.object,
  setErrorMessage: PropTypes.func,
  enableError: PropTypes.func,
  templateData: PropTypes.object,
  other: PropTypes.shape({
    checkSubdomainValid: PropTypes.func,
    fontList: PropTypes.array,
  }),
};

export { Section };
